<template>
<div>
  <el-dialog
    title="架构图"
    :visible.sync="dialogVisible"
    top="8vh"
    width="95vw"
    :close-on-click-modal="false" @close="onClose">
    <div>
      <el-date-picker
        style="width: 300px"
        size="mini"
        v-model="where.read_month"
        :clearable="false"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" @change="onChange(1)">
      </el-date-picker>
    </div>
    <MeterViewDiagram ref="MeterViewDiagram" v-if="dialogVisible&&excel_list2.length>0" :excel_list="excel_list2" />
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">关 闭</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
import moment from "moment";
import MeterViewDiagram from "./MeterNoteViewDiagram";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterNoteMap",
  inject:['mainObj','componentId','setComponentId'],
  components: {MeterViewDiagram},
  data(){
    return{
      dialogVisible:false,
      excel_list2:[],
      meter_id:"",
      where:{
        read_month:moment(new Date()).endOf('month').format("YYYY-MM"),
      }
    }
  },
  methods:{
    show(meter_id){
      const that=this;
      that.meter_id=meter_id;
      that.onChange();
    },
    onChange(type=null){
      const that=this;
      MeterHttp.post("MeterNote/getMapTree?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        ...that.where,
        meter_id:that.meter_id,
      },ret=>{
        if(ret.code){
          that.excel_list2=ret.data;
          that.dialogVisible=true;
          that.excel_list2.length&& type&&that.$refs.MeterViewDiagram.reData();
        }else {
          that.$message.error(ret.msg||"数据异常")
        }
      })
    },
    onClose(){

    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/components/MeterNoteMap.vue